import { useQuery } from "react-query";
import { getOfficeOrigin } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";

export const useGetActiveOfficeOrigin = () => {
  return useQuery("OfficeOrigin", getOfficeOrigin, {
    refetchOnWindowFocus: false,
  });
};
